export enum TokenType {
  Analytics = 'ANALYTICS',
  Reuse = 'REUSE',
  ReuseAndAnalytics = 'REUSE_AND_ANALYTICS',
}
